<script setup>
import { computed, ref, watch, defineModel, defineProps, onMounted } from 'vue';

const props = defineProps({
  attributes: {
    type: Array,
    default: () => [],
  },
});

const modelValue = defineModel({
  type: Array,
});

const selectedAttribute = ref(
  modelValue.value[0]?.attribute_key
    ? modelValue.value[0].attribute_key
    : props.attributes[0]?.attribute_key
      ? props.attributes[0]?.attribute_key
      : []
);

const attributeOptions = computed(
  () =>
    props.attributes.find(a => a.attribute_key === selectedAttribute.value)
      ?.attribute_values ?? []
);

const value = ref(
  modelValue.value[0]?.attribute_value
    ? modelValue.value[0].attribute_value
    : attributeOptions.value.length > 0
      ? attributeOptions.value[0]
      : null
);

const attributeTypeMap = computed(() =>
  props.attributes.reduce(
    (acc, curr) => ({
      ...acc,
      [curr.attribute_key]: curr.attribute_display_type,
    }),
    {}
  )
);

watch(selectedAttribute, () => {
  value.value =
    attributeOptions.value.length > 0 ? attributeOptions.value[0] : null;
});

watch([selectedAttribute, value], () => {
  modelValue.value = {
    attribute_key: selectedAttribute.value,
    attribute_value: value.value,
  };
});

onMounted(() => {
  modelValue.value = {
    attribute_key: selectedAttribute.value,
    attribute_value: value.value,
  };
});
</script>

<template>
  <select v-model="selectedAttribute">
    <option
      v-for="conversationAttribute in attributes"
      :key="conversationAttribute.attribute_key"
      :value="conversationAttribute.attribute_key"
    >
      {{ conversationAttribute.attribute_display_name }}
    </option>
  </select>
  <select v-if="attributeTypeMap[selectedAttribute] === 'list'" v-model="value">
    <option v-for="option in attributeOptions" :key="option">
      {{ option }}
    </option>
  </select>
</template>
